import React from "react";
import {Checkbox} from "@material-ui/core";

const CheckboxField = props => {
    const {fieldValue = {}, setValue} = props;
    return (
        <Checkbox
            onChange={(e) => setValue(e, {label: '', value: e.target.checked})}
            checked={Boolean(fieldValue ? fieldValue.value : false)}
            size={"small"}
        />
    )
}

export default CheckboxField;